/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ClaimStatus {
    Sonstiges = 'Sonstiges',
    Ausstehend = 'Ausstehend',
    Kulanz = 'Kulanz',
    Wartend = 'Wartend',
    Anwalt = 'Anwalt',
    InBearbeitung = 'InBearbeitung',
    GeschlossenOhneZahlung = 'GeschlossenOhneZahlung',
    Abgelehnt = 'Abgelehnt',
    Erledigt = 'Erledigt',
    DoppeltErstellt = 'DoppeltErstellt',
    InKlaerung = 'InKlaerung'
  }

    export const ClaimStatusTranslocoMap: Record<ClaimStatus, string> = {
    [ClaimStatus.Sonstiges]: 'claimStatus.sonstiges',
    [ClaimStatus.Ausstehend]: 'claimStatus.ausstehend',
    [ClaimStatus.Kulanz]: 'claimStatus.kulanz',
    [ClaimStatus.Wartend]: 'claimStatus.wartend',
    [ClaimStatus.Anwalt]: 'claimStatus.anwalt',
    [ClaimStatus.InBearbeitung]: 'claimStatus.inBearbeitung',
    [ClaimStatus.GeschlossenOhneZahlung]: 'claimStatus.geschlossenOhneZahlung',
    [ClaimStatus.Abgelehnt]: 'claimStatus.abgelehnt',
    [ClaimStatus.Erledigt]: 'claimStatus.erledigt',
    [ClaimStatus.DoppeltErstellt]: 'claimStatus.doppeltErstellt',
    [ClaimStatus.InKlaerung]: 'claimStatus.inKlaerung',
    };

    export const ClaimStatusOptions = [
  { value: ClaimStatus.Sonstiges, labelKey: 'claimStatus.sonstiges' },
  { value: ClaimStatus.Ausstehend, labelKey: 'claimStatus.ausstehend' },
  { value: ClaimStatus.Kulanz, labelKey: 'claimStatus.kulanz' },
  { value: ClaimStatus.Wartend, labelKey: 'claimStatus.wartend' },
  { value: ClaimStatus.Anwalt, labelKey: 'claimStatus.anwalt' },
  { value: ClaimStatus.InBearbeitung, labelKey: 'claimStatus.inBearbeitung' },
  { value: ClaimStatus.GeschlossenOhneZahlung, labelKey: 'claimStatus.geschlossenOhneZahlung' },
  { value: ClaimStatus.Abgelehnt, labelKey: 'claimStatus.abgelehnt' },
  { value: ClaimStatus.Erledigt, labelKey: 'claimStatus.erledigt' },
  { value: ClaimStatus.DoppeltErstellt, labelKey: 'claimStatus.doppeltErstellt' },
  { value: ClaimStatus.InKlaerung, labelKey: 'claimStatus.inKlaerung' },
    ];

